/* eslint-disable class-methods-use-this */
// ---------------- Start External Library Import --------------------//
import React from "react";
import { Link } from "react-router-dom";
import Signin from "@techsoftware/happay-widgets/Signin";
import { isMobile, detectBrowser } from "@techsoftware/happay-widgets/CommonFunction/commonFunction";
// ---------------- End External Library Import --------------------//

// ------------------- Start Constants Dependency Import -------------------------------------//
import SSOList from "../../constants/basicConfig";
// ------------------- End Constants Dependency Import -------------------------------------//

// ------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
// ------------------- End Actions Dependency Import -------------------------------------//

// ------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
import Common from "../../constants/common";
// ------------------- End Helpers Dependency Import -------------------------------------//

import AppIcon from "../../../public/assets/images/browserIcon/expense_web.svg";
import ChromeIcon from "../../../public/assets/images/browserIcon/Google_Chrome.svg";
import SafariIcon from "../../../public/assets/images/browserIcon/Safari_browser_logo.svg";
import FirefoxIcon from "../../../public/assets/images/browserIcon/firefox-logo.svg";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";
import poweredByHappay from "../../../public/assets/images/poweredByHappayImg.svg";

const androidConfig = {
    id: "com.happay.android.v2",
    platform: "play",
    url: "https://play.google.com/store/apps/details?id=com.happay.android.v2&hl=en",
    name: "Happay Expense",
    logo: AppIcon
};

const iosConfig = {
    id: "1169381152",
    platform: "itunes",
    url: "https://itunes.apple.com/za/app/happay-enterprise/id1169381152?mt=8",
    name: "Happay Expense",
    logo: AppIcon
};
export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this._handleSSOButtonClick = this._handleSSOButtonClick.bind(this);
    }

    onSignIn = value => {
        LoginAction.preLoginApi(
            { user: value.emailID || value.phoneNo, mobile_extension: value.code },
            value.activeTab
        );
    };

    returnSSOPage = () => {
        return (
            <Link className="pointer font-12 fw-500 primary-color" to="/login/sso">
                Login via single sign-on (SSO)
            </Link>
        );
    };

    _handleSSOButtonClick() {
        LoginAction._checkSSO();
    }

    render() {
        const {
            ProductLogo,
            allCountryCode,
            breakPoints,
            privacyPolicyUrl,
            termOfUseUrl,
            searchParams
        } = this.props;
        const isSSOLogin = SSOList.isSSO();
        const browser = detectBrowser();
        // console.log("Check for HDFC Bank: ", Common._checkIfHdfcUrl());
        return (
            <div>
                <Signin
                    containerClassName={`signin-container ${
                        Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
                    }`}
                    logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                    onSignIn={this.onSignIn}
                    breakPoints={breakPoints}
                    countryCode={allCountryCode}
                    footerSubHeader={
                        !Common._checkIfHdfcUrl() ? (
                            i18n.t("logIn.weAreAlsoAvailable")
                        ) : (
                            <>
                                <div className="d-flex alignItemCenter">
                                    {i18n.t("lbl.poweredBy")}
                                    <img src={poweredByHappay} width="80" className="margin-lr-5" />
                                </div>
                            </>
                        )
                    }
                    privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                    termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                    androidAppUrl={
                        !Common._checkIfHdfcUrl() &&
                        "https://play.google.com/store/apps/details?id=com.happay.android.v2&hl=en"
                    }
                    iphoneAppUrl={
                        !Common._checkIfHdfcUrl() &&
                        "https://itunes.apple.com/za/app/happay-enterprise/id1169381152?mt=8"
                    }
                    privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
                    termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
                    signInHeader={i18n.t("logIn.signText")}
                    emailIdFloatingLabelText={i18n.t("logIn.emailId")}
                    emailIdHintText={i18n.t("placeholder.emailIdHintText")}
                    codeLabelText={i18n.t("lbl.code")}
                    phoneNoFoatingLabelText={i18n.t("tableHeader.phoneNumber")}
                    phoneNoHintText={i18n.t("placeholder.phoneNoHintText")}
                    nextButtonText={i18n.t("btn.next")}
                    phoneNoErrorStr={i18n.t("err.pleaseEnterPhoneNumber")}
                    emailEmptyErrorStr={i18n.t("err.emailIDCannotBeEmpty")}
                    phoenNoLengthErrorStr={i18n.t("err.lengthShouldBeDigits")}
                    emailValidErrorStr={i18n.t("err.enterValidEmailID")}
                    tabs={[
                        {
                            label: i18n.t("lbl.mobile"),
                            icon: "phone",
                            value: 1
                        },
                        {
                            label: i18n.t("lbl.email"),
                            icon: "email",
                            value: 2
                        }
                    ]}
                    phoneNoLengthCheck={false}
                    SSOLogin={isSSOLogin}
                    SSOPage={!isSSOLogin && this.returnSSOPage()}
                    SSOLoginText={i18n.t("logIn.usingSSOSignInHere")}
                    SSOLoginHeaderText={
                        searchParams && searchParams.includes("logout")
                            ? i18n.t("logIn.signoutTextSSO")
                            : i18n.t("logIn.signText")
                    }
                    SSOLoginClick={this._handleSSOButtonClick}
                    inputAutoFocus={isMobile ? false : true}
                    enableAppSwitch={isMobile}
                    product="Happay Expense"
                    relatedApps={{ ios: { ...iosConfig }, android: { ...androidConfig } }}
                    browserIcon={
                        browser === "Safari"
                            ? SafariIcon
                            : browser === "Firefox"
                            ? FirefoxIcon
                            : ChromeIcon
                    }
                />
            </div>
        );
    }
}
